import { useQuery, keepPreviousData } from "@tanstack/react-query";
import adminApiClient, { DeviceLogSeverity } from "../../../../../../api/admin";

const useGetDeviceErrorLogs = (
  clockId: string,
  period: string | undefined,
  severity: DeviceLogSeverity | undefined,
) => {
  const query = useQuery({
    queryKey: ["device-error-logs", clockId, period, severity],
    queryFn: () =>
      adminApiClient.getDeviceErrorLogs(clockId, period!, severity!),
    enabled: Boolean(period && severity),
    placeholderData: keepPreviousData,
    staleTime: 10 * 60 * 1000,
    gcTime: 30 * 60 * 1000,
    refetchOnWindowFocus: false,
  });

  return query;
};

export default useGetDeviceErrorLogs;
